import { getAuth } from "firebase/auth";
import Environment from '../../utils/Environement';
import UbereatsApi from "../api/UberatsApi";
import { StoreActionType } from '../constant/ActionConstant';
import AppDispatcher from '../dispatcher/AppDispatcher';
import { DeliveraStore } from '../model/delivera/DeliveraStore';
import Service, { ServiceInterface } from '../model/service/Service';
import { get, getDatabase, ref, remove, update } from "firebase/database";

const kDeliveraKey = 'delivera';
const kUberEatKey = 'ubereats';
const kLoginKey = 'login';
const kSavedCardKey = 'last_updates';

class UbereatsActionCreator {

    private api: UbereatsApi

    constructor() {
        this.api = new UbereatsApi(Environment.isDev, Environment.isPopina);
    }

    async loadUberEatServiceUser() {
        const auth = getAuth()
        const userUid = auth.currentUser?.uid
        if (userUid === undefined) {
            throw new Error("error firebase not connected");
        }
        try {
            const database = getDatabase()
            const reference = ref(database, kDeliveraKey + '/' + userUid + '/' + kUberEatKey + '/' + kLoginKey);
            const snapshot = await get(reference);
            const serviceUser = (snapshot.exists()) ? new Service(snapshot.val()) : new Service();
            AppDispatcher.dispatch({
                'type': StoreActionType.SET_UBEREATS_SERVICE,
                'data': serviceUser
            });
            if (snapshot.exists()) return this.fetchCurrentUbereatsStore(serviceUser);
            return;
        }
        catch (e) {
            throw e;
        }
    }

    async connectUberEatServiceUser(storeID: string) {
        const auth = getAuth()
        const userUid = auth.currentUser?.uid
        if (userUid === undefined) {
            throw new Error("error firebase not connected");
        }
        try {
            const res = await this.api.getUbereatsStore(storeID);
            const storeName = res.data['name'];
            const serviceData: ServiceInterface = { locationId: storeID, uid: userUid, isActive: true, service: 'ubereats', name: storeName, last_updates: [] };
            const service = new Service(serviceData);
            const database = getDatabase()
            const reference = ref(database, kDeliveraKey + '/' + userUid + '/' + kUberEatKey + '/' + kLoginKey);
            await update(reference, service.toJS());
            AppDispatcher.dispatch({
                'type': StoreActionType.SET_UBEREATS_SERVICE,
                'data': service
            });
            return this.fetchCurrentUbereatsStore(service);
        }
        catch (e) {
            throw e;
        }
    }

    async disconnectUbereatsService() {
        const auth = getAuth()
        const userUid = auth.currentUser?.uid
        if (userUid === undefined) {
            throw new Error("error firebase not connected");
        }
        try {
            const database = getDatabase()
            const reference = ref(database, kDeliveraKey + '/' + userUid + '/' + kUberEatKey + '/' + kLoginKey);
            await remove(reference);
            AppDispatcher.dispatch({
                'type': StoreActionType.SET_UBEREATS_SERVICE,
                'data': new Service()
            });
        }
        catch (e) {
            throw e;
        }
    }

    async fetchCurrentUbereatsStore(service: Service): Promise<void> {
        const auth = getAuth()
        const userUid = auth.currentUser?.uid
        if (userUid === undefined || userUid === null) throw new Error("error firebase not connected");
        try {
            const res = await this.api.getUbereatsMenu(service.locationId!);
            const store = new DeliveraStore(res.data, 'ubereats');
            AppDispatcher.dispatch({
                'type': StoreActionType.LOAD_CURRENT_UBEREATS_STORE,
                'data': store
            });
            return
        }
        catch (e) {
            throw e;
        }
    }

    async sendStoreToUbereast(store: DeliveraStore, service: Service): Promise<void> {
        try {
            const auth = getAuth()
            const userUid = auth.currentUser?.uid
            if (userUid === undefined || userUid === null) {
                throw new Error('no user loged error');
            }

            const key = new Date().getTime().toString();
            const updateData = {} as any;
            updateData[key] = store.prepareForSend();

            const database = getDatabase()
            const reference = ref(database, kDeliveraKey + '/' + userUid + '/' + kUberEatKey + '/' + kLoginKey + '/' + kSavedCardKey);
            await update(reference, updateData);

            await this.api.updateUbereatsMenu(service.locationId!, store.prepareForSend());
            return;
        }
        catch (e) {
            throw e;
        }
    }

    async sendStoreToUbereastWithoutSave(store: DeliveraStore, service: Service): Promise<void> {
        try {
            await this.api.updateUbereatsMenu(service.locationId!, store);
            return;
        }
        catch (e) {
            throw e;
        }
    }
}

const uberEatsActionCreator = new UbereatsActionCreator();
export default uberEatsActionCreator;